import React from "react";
import Layoute from "../components/layoute";
import {
  Input,
  Form,
  DatePicker,
  TimePicker,
  Card,
  Col,
  Row,
  Button,
  Icon,
  Tag,
  Modal,
  Table,
  Select,
  Badge,
  Upload,
  Pagination,
  notification,
} from "antd";
import moment from "moment";

const { TextArea } = Input;
const FormItem = Form.Item;
const MonthPicker = DatePicker.MonthPicker;
const RangePicker = DatePicker.RangePicker;
const Option = Select.Option;
const OptGroup = Select.OptGroup;

moment.locale("fr");

const columns = [
  {
    title: "Nom",
    dataIndex: "name",
    onFilter: (value, record) => record.name.indexOf(value) === 0,
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: "Téléphone",
    dataIndex: "phone",
    defaultSortOrder: "descend",
    sorter: (a, b) => a.age - b.age,
  },
  {
    title: "Société",
    dataIndex: "company",
    filterMultiple: false,
    onFilter: (value, record) => record.address.indexOf(value) === 0,
    sorter: (a, b) => a.address.length - b.address.length,
  },
];

function onChange(pagination, filters, sorter) {
  console.log("params", pagination, filters, sorter);
}

class Meeting extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      text: "",
      ModalText: "Content of the modal",
      visible: false,
      visible2: false,
      visibleModification: false,
      visibleRefus: false,
      confirmLoading: false,
      selectedMeeting: [],
      selectedMeeting2: [],
      subscribe: true,
      meetings: [],
      fileList: [],
      modificationFileList: [],
      removedAttachments: [],
      loadingMeetings: true,
    };
  }

  componentDidMount() {
    fetch("/api/meeting", {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("x-access-token"),
      },
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          meetings: data.meetings,
          loadingMeetings: false,
        });

        fetch("/api/user", {
          credentials: "include",
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": localStorage.getItem("x-access-token"),
          },
        })
          .then((res) => res.json())
          .then((data) => {
            this.setState({
              users: data.users,
              filterData: data.users,
              groups: data.groups,
            });
          });
      });
  }

  handleChange(value) {
    this.setState({ text: value });
  }

  // Modal participants
  showModal = (meeting) => {
    this.setState({
      visible: true,
      selectedMeeting2: meeting,
    });
  };

  // Modal creation
  showModalCreation = (type) => {
    this.setState({
      visible2: true,
      type: type == "lehubbezannes" ? "lehubbezannes" : null,
    });
  };

  // Modal modification
  showModalModification = (meeting) => {
    this.setState({
      visibleModification: true,
      selectedMeeting: meeting,
      modificationFileList: [],
      removedAttachments: [],
    });
  };

  // Modal refus
  showModalRefus = (meeting) => {
    this.setState({
      visibleRefus: true,
      selectedMeeting: meeting,
    });
  };

  handleOkModification = (e) => {
    this.props.form.validateFields((err, values) => {
      if (err) return;

      const formData = new FormData();
      this.state.modificationFileList.forEach((file) => {
        formData.append("files[]", file);
      });
      Object.keys(values).map((key) => {
        formData.append(key, values[key]);
      });
      formData.append("id", this.state.selectedMeeting._id);
      formData.append(
        "removedAttachments",
        JSON.stringify(this.state.removedAttachments)
      );

      this.setState({ confirmLoading: true });

      fetch("/api/meeting", {
        credentials: "include",
        method: "PUT",
        headers: {
          "x-access-token": localStorage.getItem("x-access-token"),
        },
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          var oldMeetings = this.state.meetings.filter((d) => {
            return d._id !== this.state.selectedMeeting._id;
          });

          this.setState({
            meetings: [...oldMeetings, data],
            visibleModification: false,
            confirmLoading: false,
            modificationFileList: [],
            removedAttachments: [],
          });
          notification["success"]({
            message: "Demande modifiée",
            description:
              "La demande a été modifiée et est en cours de validation",
          });
        });
    });
  };

  handleOkRefus = (meeting) => {
    this.setState({
      confirmLoading: true,
    });

    const status = this.state.selectedMeeting.status;

    this.props.form.validateFields((err, values) => {
      fetch("/api/meeting/refuse", {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": localStorage.getItem("x-access-token"),
        },
        body: JSON.stringify({
          id: this.state.selectedMeeting._id,
          status: "refused",
          explanation: values.explanation,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          this.state.selectedMeeting.validator = JSON.parse(
            localStorage.getItem("user")
          );
          this.state.selectedMeeting.status = "refused";
          this.state.selectedMeeting.explanation = values.explanation;
          this.setState({
            visibleRefus: false,
            confirmLoading: false,
          });

          notification["error"]({
            message: "Evenement refusé",
            description: "L'évènement a été refusé",
          });
        });
    });
  };

  handleCancelModification = (e) => {
    console.log(e);
    this.setState({
      visibleModification: false,
      modificationFileList: [],
      removedAttachments: [],
    });
  };

  handleCancelRefus = (e) => {
    console.log(e);
    this.setState({
      visibleRefus: false,
    });
  };

  createEvent = (e) => {
    this.setState({
      confirmLoading: true,
    });
    this.props.form.validateFields((err, values) => {
      if (err) {
        this.setState({ confirmLoading: false });
        return;
      }

      const formData = new FormData();
      this.state.fileList.forEach((file) => {
        formData.append("files[]", file);
      });
      Object.keys(values).map((key) => {
        formData.append(key, values[key]);
      });

      if (this.state.type == "lehubbezannes") formData.append("leHubBezannesAuthor", true);

      fetch("/api/meeting", {
        credentials: "include",
        method: "POST",
        headers: {
          "x-access-token": localStorage.getItem("x-access-token"),
        },
        body: formData,
      })
        .then((res) => {
          return res.json().catch(() => ({})).then((data) => {
            if (!res.ok) {
              throw new Error(
                data.message ||
                  "Impossible d'enregistrer l'évènement (HTTP " + res.status + ")"
              );
            }
            return data;
          });
        })
        .then((data) => {
          this.props.form.resetFields();
          data.author = JSON.parse(localStorage.getItem("user"));

          this.setState({
            meetings: [...this.state.meetings, data],
            visible2: false,
            confirmLoading: false,
            type: null,
          });

          notification["success"]({
            message: "Demande envoyée",
            description:
              "La demande a été envoyée et est en cours de validation",
          });
        })
        .catch((error) => {
          this.setState({ confirmLoading: false });
          notification["error"]({
            message: "Envoi impossible",
            description: error.message || "Veuillez réessayer.",
          });
        });
    });
  };

  handleCancelCreation = (e) => {
    this.props.form.resetFields();
    this.setState({
      visible2: false,
      confirmLoading: false,
      type: null,
    });
  };

  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  validateMeeting(meeting) {
    this.setState({
      loading: true,
    });

    fetch("/api/meeting/custom", {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("x-access-token"),
      },
      body: JSON.stringify({
        id: meeting._id,
        status: "validated",
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        const validator = JSON.parse(localStorage.getItem("user"));
        this.setState({
          loading: false,
          meetings: this.state.meetings.map((item) =>
            item._id === meeting._id
              ? {
                  ...item,
                  status: "validated",
                  validator,
                }
              : item
          ),
        });
        notification["success"]({
          message: "Evenement validé",
          description: "L'évènement a été validé",
        });
      });
  }

  deleteMeeting(meeting) {
    console.log(meeting._id);
    this.setState({
      loading: true,
    });
    fetch("/api/meeting", {
      credentials: "include",
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("x-access-token"),
      },
      body: JSON.stringify({
        id: meeting._id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          meetings: this.state.meetings.filter((a) => {
            return a._id !== meeting._id;
          }),
          loading: false,
        });
      });
  }

  disabledDate(current) {
    // Can not select days before today and today
    return current && moment().isSameOrAfter(current);
  }

  handleFilter(val, option) {
    console.log(option);
    return (
      !option.props.filter ||
      option.props.filter.toLowerCase().indexOf(val ? val.toLowerCase() : "") >=
        0
    );
  }

  onRemove(file) {
    const index = this.state.fileList.indexOf(file);
    const newFileList = this.state.fileList.slice();
    newFileList.splice(index, 1);
    this.setState({
      fileList: newFileList,
    });
    return {
      fileList: newFileList,
    };
  }

  beforeUpload(file) {
    this.setState({
      fileList: [...this.state.fileList, file],
    });
    return false;
  }

  onRemoveModification(file) {
    const index = this.state.modificationFileList.indexOf(file);
    const modificationFileList = this.state.modificationFileList.slice();
    modificationFileList.splice(index, 1);
    this.setState({ modificationFileList });
    return false;
  }

  beforeUploadModification(file) {
    this.setState({
      modificationFileList: [...this.state.modificationFileList, file],
    });
    return false;
  }

  removeExistingAttachment(attachment) {
    this.setState({
      removedAttachments: [...this.state.removedAttachments, attachment.path],
      selectedMeeting: {
        ...this.state.selectedMeeting,
        attachments: (this.state.selectedMeeting.attachments || []).filter(
          (item) => item.path !== attachment.path
        ),
      },
    });
  }

  render() {
    const { visible, visibleRefus, visibleModification, confirmLoading } =
      this.state;
    const ReactQuill = this.quill;
    const { getFieldDecorator } = this.props.form;

    const dateLocale = {
      lang: {
        placeholder: "Sélectionner une date",
        rangePlaceholder: ["Start date", "End date"],
        today: "Aujourd'hui",
        now: "Now",
        backToToday: "Back to today",
        ok: "Ok",
        clear: "Clear",
        month: "Month",
        year: "Year",
        timeSelect: "Sélectionner une heure",
        dateSelect: "Sélectionner une date",
        monthSelect: "Choose a month",
        yearSelect: "Choose a year",
        decadeSelect: "Choose a decade",
        yearFormat: "YYYY",
        dateFormat: "M/D/YYYY",
        dayFormat: "D",
        dateTimeFormat: "M/D/YYYY HH:mm:ss",
        monthFormat: "MMMM",
        monthBeforeYear: true,
        previousMonth: "Previous month (PageUp)",
        nextMonth: "Next month (PageDown)",
        previousYear: "Last year (Control + left)",
        nextYear: "Next year (Control + right)",
        previousDecade: "Last decade",
        nextDecade: "Next decade",
        previousCentury: "Last century",
        nextCentury: "Next century",
      },
      timePickerLocale: {
        placeholder: "Sélectionner une heure",
      },
    };

    const config = {
      rules: [
        {
          type: "object",
          required: true,
          message: "Merci de sélectioner une date",
        },
      ],
    };
    const rangeConfig = {
      rules: [
        {
          type: "object",
          required: true,
          message: "Merci de sélectioner une date",
        },
      ],
    };

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return (
      <div className="padding" style={{ padding: "30px" }}>
        <div
          className="buttonsContainer"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          {(this.props.user.group &&
            this.props.user.group.findIndex(
              (f) => f.slug == "membre-du-bureau"
            ) !== -1) ||
          this.props.user.admin ? (
            <Button
              type="primary"
              size="large"
              onClick={() => this.showModalCreation("lehubbezannes")}
              style={{ marginRight: 10 }}
            >
              <Icon type="plus-circle-o" />
              Évenement Le Hub Bezannes
            </Button>
          ) : null}
          {this.props.user.company.status == "actif" ? (
            <Button
              type="primary"
              size="large"
              onClick={this.showModalCreation}
            >
              <Icon type="plus-circle-o" />
              Proposer un évènement
            </Button>
          ) : (
            <Button type="primary" size="large" disabled>
              <Icon type="plus-circle-o" />
              Proposer un évènement
            </Button>
          )}
        </div>
        {this.props.user.company.status == "actif" ? (
          this.state.meetings.length > 0 ? (
            <div>
              <Row gutter={16}>
                {this.state.meetings
                  .slice((this.state.page - 1) * 3, this.state.page * 3)
                  .map((meeting) => {
                    return (
                      <Col
                        key={meeting._id}
                        xs={{ span: 24 }}
                        sm={{ span: 24 }}
                        md={{ span: 24 }}
                        lg={{ span: 12 }}
                        xl={{ span: 8 }}
                        style={{ marginBottom: "30px", minHeight: 350 }}
                      >
                        <Card
                          hoverable
                          title={meeting.title}
                          style={{ height: "100%", overflow: "hidden" }}
                          extra={
                            this.props.user.admin ||
                              this.props.user.group.filter((f) => {
                                return f.slug == "membre-du-bureau";
                              }).length > 0 ? (
                              <div>
                                {meeting.status != "validated" ? (
                                  <React.Fragment>
                                    <Button
                                      type="primary"
                                      disabled={this.state.loading}
                                      onClick={() => this.validateMeeting(meeting)}
                                    >
                                      Valider
                                    </Button>
                                    {meeting.status != "refused" ? (
                                      <Button
                                        style={{ marginLeft: 10 }}
                                        type="danger"
                                        disabled={this.state.loading}
                                        onClick={() => {
                                          this.showModalRefus(meeting);
                                        }}
                                      >
                                        Refuser
                                      </Button>
                                    ) : null}
                                  </React.Fragment>
                                ) : null}
                                <Button
                                  style={{ marginLeft: meeting.status != "validated" ? 10 : 0 }}
                                  type="danger"
                                  disabled={this.state.loading}
                                  onClick={() => {
                                    Modal.confirm({
                                      title: "Confirmer la suppression de la demande",
                                      content:
                                        "Cette action retire uniquement l'entrée de Demandes / Événements.",
                                      okText: "Supprimer",
                                      okType: "danger",
                                      cancelText: "Annuler",
                                      onOk: () => this.deleteMeeting(meeting),
                                    });
                                  }}
                                >
                                  Supprimer
                                </Button>
                              </div>
                            ) : null
                          }
                        >
                          <div
                            style={{
                              position: "relative",
                              top: 0,
                              left: 0,
                              marginBottom: 15,
                            }}
                            className="status"
                          >
                            {meeting.status == "refused" ? (
                              <Tag color="red">
                                Refusé par {meeting.validator.firstname}{" "}
                                {meeting.validator.lastname}
                              </Tag>
                            ) : null}
                            {meeting.status == "validated" ? (
                              <Tag color="green">
                                Validé par {meeting.validator.firstname}{" "}
                                {meeting.validator.lastname}
                              </Tag>
                            ) : null}
                            {meeting.status == "waiting" ? (
                              <Tag color="orange">En attente de validation</Tag>
                            ) : null}
                          </div>
                          <p>
                            {" "}
                            <Icon type="calendar" /> &nbsp;
                            {moment(meeting.date).format("DD MMMM YYYY")} -{" "}
                            {moment(meeting.timeStart).format("HH:mm") +
                              " à " +
                              moment(meeting.timeEnd).format("HH:mm")}
                          </p>
                          <p>
                            <Icon type="home" /> &nbsp;{meeting.address}
                          </p>
                          <p>
                            <Icon type="user" /> &nbsp;
                            {meeting.author.firstname} {meeting.author.lastname}
                          </p>
                          <p style={{ whiteSpace: "pre-wrap" }}>
                            {meeting.description}
                          </p>
                          {meeting.attachments && meeting.attachments.length > 0 ? (
                            <div style={{ marginBottom: 12 }}>
                              <b>Pièces jointes :</b>
                              {meeting.attachments.map((attachment) => (
                                <div key={attachment.path}>
                                  <a href={attachment.path} target="_blank">
                                    <Icon type="paper-clip" /> {attachment.filename}
                                  </a>
                                </div>
                              ))}
                            </div>
                          ) : null}
                          {meeting.invitation && meeting.invitation.length > 0 ? (
                            <div style={{ marginBottom: 12 }}>
                              <b>Invités :</b>{" "}
                              {meeting.invitation.map((invitation) => (
                                <Tag key={invitation}>{invitation}</Tag>
                              ))}
                            </div>
                          ) : null}
                          {meeting.status == "refused" ? (
                            <div>
                              <div className="explanation">
                                {meeting.explanation}
                              </div>
                              <div className="authorExplanation">
                                <Icon type="user" /> &nbsp; Refusé par{" "}
                                {meeting.validator.firstname}{" "}
                                {meeting.validator.lastname}
                              </div>
                            </div>
                          ) : null}
                        </Card>
                      </Col>
                    );
                  })}
              </Row>
              <Pagination
                current={this.state.page}
                onChange={(page) => this.setState({ page })}
                pageSize={3}
                total={this.state.meetings.length}
              />
            </div>
          ) : this.state.loadingMeetings ? (
            ""
          ) : (
            <div className="unauthorized">
              <div className="error-logo"></div>
              <div className="text">
                <h1>Vous n'avez pas encore proposé d'évènements</h1>
                <p>
                  Pour créer et partager vos évènements, cliquez sur le bouton
                  "Proposer un évènement" situé en haut à droite de la page.{" "}
                  <br />
                  Une fois effectué, votre demande sera examinée par les membres
                  du bureau avant d'être partagé aux adhérents de l'assocation
                </p>
              </div>
            </div>
          )
        ) : (
          <div className="unauthorized">
            <div className="error-logo"></div>
            <div className="text">
              <h1>Vous n'êtes pas adhérent actif sur l'année en cours</h1>
              <p>
                Pour créer et partager vos évènements aux entreprises du Parc
                d'Affaires Reims Bezannes, vous devez être adhérent actif sur
                l'année en cours.
                <br />
                Pour renouveler ou adhérer à l'association,{" "}
                <a onClick={this.props.adModal}>cliquez ici</a>
              </p>
            </div>
          </div>
        )}
        <Modal
          title="Participants au meeting"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          destroyOnClose={true}
        >
          <Table
            columns={columns}
            dataSource={this.state.selectedMeeting2.participants}
            onChange={onChange}
          />
        </Modal>
        <Modal
          title="Modifier Meeting"
          visible={this.state.visibleModification}
          onOk={this.handleOkModification}
          onCancel={this.handleCancelModification}
          confirmLoading={confirmLoading}
          destroyOnClose={true}
          width={700}
        >
          <Form>
            <FormItem {...formItemLayout} label={<span>Titre&nbsp;</span>}>
              {getFieldDecorator("title", {
                rules: [
                  {
                    required: true,
                    message: "Merci de renseigner un titre",
                    whitespace: true,
                  },
                ],
                initialValue: this.state.selectedMeeting.title,
              })(<Input />)}
            </FormItem>
            <FormItem {...formItemLayout} label="Pièce(s) jointe(s)">
              {(this.state.selectedMeeting.attachments || []).map((attachment) => (
                <div key={attachment.path} style={{ marginBottom: 8 }}>
                  <a href={attachment.path} target="_blank">
                    <Icon type="paper-clip" /> {attachment.filename}
                  </a>
                  <Button
                    size="small"
                    type="danger"
                    style={{ marginLeft: 10 }}
                    onClick={() => this.removeExistingAttachment(attachment)}
                  >
                    Retirer
                  </Button>
                </div>
              ))}
              <Upload
                onRemove={(file) => this.onRemoveModification(file)}
                fileList={this.state.modificationFileList}
                beforeUpload={(file) => this.beforeUploadModification(file)}
              >
                <Button>
                  <Icon type="upload" /> Ajouter des pièces jointes
                </Button>
              </Upload>
            </FormItem>
            <FormItem {...formItemLayout} label="Date">
              {getFieldDecorator("date", {
                initialValue: this.state.selectedMeeting.date
                  ? moment(this.state.selectedMeeting.date)
                  : null,
                rules: [
                  {
                    type: "object",
                    required: true,
                    message: "Merci de sélectioner une date",
                  },
                ],
              })(
                <DatePicker
                  format="DD MMMM YYYY"
                  disabledDate={this.disabledDate}
                  locale={dateLocale}
                  placeholder="Sélectionner une date"
                  style={{ width: "100%" }}
                />
              )}
            </FormItem>
            <FormItem {...formItemLayout} label="Heure de début">
              {getFieldDecorator("timeStart", {
                initialValue: this.state.selectedMeeting.timeStart
                  ? moment(this.state.selectedMeeting.timeStart)
                  : null,
                rules: [
                  {
                    required: true,
                    message: "Ce champ est obligatoire",
                  },
                ],
              })(
                <TimePicker
                  style={{ width: "100%" }}
                  minuteStep={15}
                  placeholder="Début"
                  defaultOpenValue={moment("10:00", "HH:mm")}
                  format={"HH:mm"}
                />
              )}
            </FormItem>

            <FormItem {...formItemLayout} label="Heure de fin">
              {getFieldDecorator("timeEnd", {
                initialValue: this.state.selectedMeeting.timeEnd
                  ? moment(this.state.selectedMeeting.timeEnd)
                  : null,
                rules: [
                  {
                    required: true,
                    message: "Ce champ est obligatoire",
                  },
                ],
              })(
                <TimePicker
                  style={{ width: "100%" }}
                  minuteStep={15}
                  placeholder="Fin"
                  defaultOpenValue={moment("17:00", "HH:mm")}
                  format={"HH:mm"}
                />
              )}
            </FormItem>
            <FormItem {...formItemLayout} label="Lieu">
              {getFieldDecorator("address", {
                initialValue: this.state.selectedMeeting.address,
                rules: [
                  {
                    required: true,
                    message: "Merci de préciser un lieu",
                    whitespace: true,
                  },
                ],
              })(<Input placeholder={"Précisez le lieu de l'évènement"} />)}
            </FormItem>
            <FormItem {...formItemLayout} label="Invitations">
              {getFieldDecorator("invitation", {
                initialValue: this.state.selectedMeeting.invitation || [],
                rules: [
                  {
                    required: true,
                    message: "Merci de préciser à qui s'adresse cet évènement",
                  },
                ],
              })(
                <Select
                  mode="multiple"
                  style={{ width: "100%" }}
                  placeholder="Sélectionner un groupe ou des utilisateurs"
                  filter
                  optionFilterProp="filter"
                  notFoundContent={null}
                >
                  <OptGroup label="Année en cours">
                    <Option
                      filter="actif"
                      value="group-actif"
                      key={"group-actif"}
                    >
                      <b
                        style={{
                          textTransform: "uppercase",
                        }}
                      >
                        <Badge status="success" /> Actifs
                      </b>
                    </Option>
                    <Option
                      filter="passif"
                      value="group-passif"
                      key={"group-passif"}
                    >
                      <b
                        style={{
                          textTransform: "uppercase",
                        }}
                      >
                        <Badge status="warning" /> Passifs
                      </b>
                    </Option>
                  </OptGroup>
                  <OptGroup label="Groupes">
                    {this.state.groups
                      ? this.state.groups.map((g) => {
                          return (
                            <Option filter={g.slug} key={"group-" + g.slug}>
                              <b>
                                <Badge status="default" />
                                {g.title}
                              </b>
                            </Option>
                          );
                        })
                      : ""}
                  </OptGroup>
                  <OptGroup label="Utilisateurs">
                    {this.state.users
                      ? this.state.users
                          .filter((u) => {
                            return u.email;
                          })
                          .map((u) => {
                            return (
                              <Option
                                filter={
                                  u.company.name +
                                  " " +
                                  u.firstname +
                                  " " +
                                  u.lastname
                                }
                                key={u.email}
                                value={u.email}
                              >
                                <b>
                                  {u.company
                                    ? u.company.name.trim().toUpperCase() +
                                      " - "
                                    : ""}
                                </b>{" "}
                                {u.lastname ? u.lastname.toUpperCase() : ""}{" "}
                                {u.firstname
                                  ? u.firstname.trim().charAt(0)
                                  : ""}
                                .
                              </Option>
                            );
                          })
                      : ""}
                  </OptGroup>
                </Select>
              )}
            </FormItem>
            <FormItem {...formItemLayout} label="Description">
              {getFieldDecorator("description", {
                rules: [
                  {
                    required: true,
                    message: "Courte description de l'évènement",
                  },
                ],
                initialValue: this.state.selectedMeeting.description,
              })(
                <TextArea
                  placeholder=""
                  autosize={{ minRows: 10, maxRows: 50 }}
                />
              )}
            </FormItem>
          </Form>
        </Modal>

        <Modal
          title="Création d'évènement"
          visible={this.state.visible2}
          onOk={this.createEvent}
          onCancel={this.handleCancelCreation}
          confirmLoading={this.state.confirmLoading}
          cancelText="Annuler"
          destroyOnClose={true}
          width={900}
        >
          <Form>
            <FormItem {...formItemLayout} label="Titre">
              {getFieldDecorator("title", {
                rules: [
                  {
                    required: true,
                    message: "Merci de renseigner un titre",
                    whitespace: true,
                  },
                ],
              })(<Input placeholder={"Titre de l'évènement"} />)}
            </FormItem>
            <FormItem {...formItemLayout} label="Pièce(s) jointe(s)">
              <Upload
                onRemove={(file) => this.onRemove(file)}
                fileList={this.state.fileList}
                beforeUpload={(file) => this.beforeUpload(file)}
                name="logo"
              >
                <Button>
                  <Icon type="upload" /> Sélectionner les pièces jointes à
                  ajouter
                </Button>
              </Upload>
            </FormItem>
            <FormItem {...formItemLayout} label="Date">
              {getFieldDecorator("date", {
                rules: [
                  {
                    type: "object",
                    required: true,
                    message: "Merci de sélectioner une date",
                  },
                ],
              })(
                <DatePicker
                  format="DD MMMM YYYY"
                  disabledDate={this.disabledDate}
                  locale={dateLocale}
                  placeholder="Sélectionner une date"
                  style={{ width: "100%" }}
                />
              )}
            </FormItem>
            <FormItem {...formItemLayout} label="Heure de début">
              {getFieldDecorator("timeStart", {
                rules: [
                  {
                    required: true,
                    message: "Ce champ est obligatoire",
                  },
                ],
              })(
                <TimePicker
                  style={{ width: "100%" }}
                  minuteStep={15}
                  placeholder="Début"
                  defaultOpenValue={moment("10:00", "HH:mm")}
                  format={"HH:mm"}
                />
              )}
            </FormItem>

            <FormItem {...formItemLayout} label="Heure de fin">
              {getFieldDecorator("timeEnd", {
                rules: [
                  {
                    required: true,
                    message: "Ce champ est obligatoire",
                  },
                ],
              })(
                <TimePicker
                  style={{ width: "100%" }}
                  minuteStep={15}
                  placeholder="Fin"
                  defaultOpenValue={moment("17:00", "HH:mm")}
                  format={"HH:mm"}
                />
              )}
            </FormItem>
            <FormItem {...formItemLayout} label="Lieu">
              {getFieldDecorator("address", {
                rules: [
                  {
                    required: true,
                    message: "Merci de préciser un lieu",
                    whitespace: true,
                  },
                ],
              })(<Input placeholder={"Précisez le lieu de l'évènement"} />)}
            </FormItem>
            <FormItem {...formItemLayout} label="Invitations">
              {getFieldDecorator("invitation", {
                rules: [
                  {
                    required: true,
                    message: "Merci de préciser à qui s'adresse cet évènement",
                  },
                ],
              })(
                <Select
                  mode="tags"
                  style={{ width: "100%" }}
                  placeholder="Sélectionner un groupe ou des utilisateurs"
                  filter
                  optionFilterProp="filter"
                  notFoundContent={null}
                >
                  <OptGroup label="Année en cours">
                    <Option
                      filter="actif"
                      value="group-actif"
                      key={"group-actif"}
                    >
                      <b
                        style={{
                          textTransform: "uppercase",
                        }}
                      >
                        <Badge status="success" /> Actifs
                      </b>
                    </Option>
                    <Option
                      filter="passif"
                      value="group-passif"
                      key={"group-passif"}
                    >
                      <b
                        style={{
                          textTransform: "uppercase",
                        }}
                      >
                        <Badge status="warning" /> Passifs
                      </b>
                    </Option>
                  </OptGroup>
                  <OptGroup label="Groupes">
                    {this.state.groups
                      ? this.state.groups.map((g) => {
                          return (
                            <Option filter={g.slug} key={"group-" + g.slug}>
                              <b>
                                <Badge status="default" />
                                {g.title}
                              </b>
                            </Option>
                          );
                        })
                      : ""}
                  </OptGroup>
                  <OptGroup label="Utilisateurs">
                    {this.state.users
                      ? this.state.users
                          .filter((u) => {
                            return u.email;
                          })
                          .map((u) => {
                            return (
                              <Option
                                filter={
                                  u.company.name +
                                  " " +
                                  u.firstname +
                                  " " +
                                  u.lastname
                                }
                                key={u.email}
                                value={u.email}
                              >
                                <b>
                                  {u.company
                                    ? u.company.name.trim().toUpperCase() +
                                      " - "
                                    : ""}
                                </b>{" "}
                                {u.lastname ? u.lastname.toUpperCase() : ""}{" "}
                                {u.firstname
                                  ? u.firstname.trim().charAt(0)
                                  : ""}
                                .
                              </Option>
                            );
                          })
                      : ""}
                  </OptGroup>
                </Select>
              )}
            </FormItem>
            <FormItem {...formItemLayout} label="Description">
              {getFieldDecorator("description", {
                rules: [
                  {
                    required: true,
                    message:
                      "Merci de présenter l'évènement en quelques lignes",
                  },
                ],
              })(
                <TextArea
                  placeholder={"Courte description de l'évènement"}
                  autosize={{ minRows: 5, maxRows: 10 }}
                />
              )}
            </FormItem>
          </Form>
        </Modal>

        <Modal
          title="Refus Meeting"
          visible={visibleRefus}
          onOk={this.handleOkRefus}
          confirmLoading={confirmLoading}
          onCancel={this.handleCancelRefus}
          destroyOnClose={true}
        >
          <Form>
            <FormItem {...formItemLayout} label="Explication du refus">
              {getFieldDecorator("explanation", {
                rules: [
                  {
                    required: false,
                    message: "Expliquez votre refus",
                  },
                ],
              })(
                <div>
                  <TextArea
                    placeholder="Précisez la raison du refus"
                    autosize={{
                      minRows: 15,
                      maxRows: 50,
                    }}
                  />
                </div>
              )}
            </FormItem>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default Form.create()(Meeting);



// WEBPACK FOOTER //
// ./components/meeting.js